export type ViaCepResult = {
  zipCode: string;
  address: string;
  neighborhood: string;
  city: string;
  state: string;
};

/**
 * Busca endereco pelo CEP via API publica ViaCEP.
 * Retorna null quando o CEP eh invalido, nao existe ou a rede falha.
 * Documentacao: https://viacep.com.br/
 */
export async function fetchAddressFromCep(cep: string): Promise<ViaCepResult | null> {
  const digits = cep.replace(/\D/g, "");
  if (digits.length !== 8) return null;

  try {
    const res = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
    if (!res.ok) return null;
    const data = (await res.json()) as {
      erro?: boolean;
      logradouro?: string;
      bairro?: string;
      localidade?: string;
      uf?: string;
    };
    if (data.erro) return null;
    return {
      zipCode: digits,
      address: data.logradouro ?? "",
      neighborhood: data.bairro ?? "",
      city: data.localidade ?? "",
      state: data.uf ?? "",
    };
  } catch {
    return null;
  }
}

export function formatCep(cep: string): string {
  const digits = cep.replace(/\D/g, "").slice(0, 8);
  if (digits.length <= 5) return digits;
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
}
